import { useLocation, useSearchParams } from "react-router-dom";
import { useSchedulingOrg } from "./useSchedulingOrg";
import { normalizeTimeZone } from "../../components/Admin/Scheduling/timeZones";

// Opening an existing schedule must not change its owner when the workspace changes.
export function useSchedulingOwner() {
  const context = useSchedulingOrg();
  const location = useLocation();
  const [params] = useSearchParams();
  const organizationRef = params.get("organizationRef") || location.state?.organizationRef ||
    (location.state?.data ? context.organizationRef : context.lockedOrgId || context.organizationRef);
  return { ...context, organizationRef,
    organizationTimeZone: normalizeTimeZone(context.orgOptions?.find(org => org.value === organizationRef)?.timeZone) || context.organizationTimeZone };
}
